import React from "react";
import { Link } from "react-router-dom";
import { FaGraduationCap } from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io5";
import "../css/FloatingActions.css";

const FloatingActions = () => {
  const whatsappNumber = "97798XXXXXXXX";

  const whatsappMessage = encodeURIComponent(
    "Hello Sahara Public School, I want to enquire about admissions."
  );

  return (
    <aside className="floating-sidebar">
      <Link
        to="/admission"
        className="floating-action-btn btn btn-primary"
      >
        ENQUIRE NOW
      </Link>

      <Link
        to="/contact"
        className="floating-action-btn btn btn-secondary"
      >
        BOOK A TOUR
      </Link>

      <Link
        to="/scholarship"
        className="floating-icon scholarship-icon"
        aria-label="Scholarship"
      >
        <FaGraduationCap />
      </Link>

      <a
        href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
        target="_blank"
        rel="noopener noreferrer"
        className="floating-icon whatsapp-icon"
        aria-label="WhatsApp"
      >
        <IoLogoWhatsapp />
      </a>
    </aside>
  );
};

export default FloatingActions;